const styles = () => ({
  messageWrapper: {
    marginTop: 50,
    textAlign: 'center',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/confirmEmail/styles.js